module.exports = __webpack_public_path__ + "1f43658bdeda79860d5c4224f01212a8.svg";